import { Component, OnInit } from '@angular/core';
import { DashboardComponent } from '../dashboard/dashboard.component';
import { AuthorizationService } from '../../services/authenticate-service/authorization.service';
import { LocalStorageService } from 'angular-2-local-storage';

@Component({
  selector: 'app-episode-of-care',
  templateUrl: './episode-of-care.component.html',
  styleUrls: ['./episode-of-care.component.css']
})
export class EpisodeOfCareComponent implements OnInit {

  constructor(public dashboard: DashboardComponent, public authservice: AuthorizationService, public localStorage:LocalStorageService) { }

  ngOnInit(): void {
  }

}
